import { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { text } from "@/theme/colors";
import { TLearningProgressFilterFormExtended } from "@/features/learning-progress/components/filter/learning-progress-filter-shared";
import { useTriggerValidate } from "@/hooks/useTriggerValidate";

type TFilterKey = keyof TLearningProgressFilterFormExtended;

type NumberRangeFieldProps = {
  label: string;
  fromKey: TFilterKey;
  toKey: TFilterKey;
};

export const NumberRangeField: FC<NumberRangeFieldProps> = ({ label, fromKey, toKey }) => {
  const methods = useFormContext<TLearningProgressFilterFormExtended>();

  useTriggerValidate({ methods, name: fromKey, triggerFields: [toKey] });

  return (
    <Stack spacing={0.5}>
      <Typography variant="cap12Light">{label}</Typography>
      <Stack direction="row" alignItems="flex-start" spacing={1}>
        <Box flex={1}>
          <FormField control={methods.control} name={fromKey}>
            <Input placeholder="入力してください" transformToHalfWidth clearable={false} commasFormat={false} />
          </FormField>
        </Box>
        <Typography variant="cap12" color={text.secondary} sx={{ pt: "10px" }}>
          〜
        </Typography>
        <Box flex={1}>
          <FormField control={methods.control} name={toKey}>
            <Input placeholder="入力してください" transformToHalfWidth clearable={false} commasFormat={false} />
          </FormField>
        </Box>
      </Stack>
    </Stack>
  );
};
